// extracted by mini-css-extract-plugin
module.exports = {"badge":"AssignmentBadge_badge__30orI","badgeLarge":"AssignmentBadge_badgeLarge__3HoKt AssignmentBadge_badge__30orI"};